import { render, staticRenderFns } from "./SwissConstant.vue?vue&type=template&id=0882a75a&scoped=true&"
import script from "./SwissConstant.vue?vue&type=script&lang=js&"
export * from "./SwissConstant.vue?vue&type=script&lang=js&"
import style0 from "./SwissConstant.vue?vue&type=style&index=0&id=0882a75a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0882a75a",
  null
  
)

export default component.exports